import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    ...theme.shape.componentSpacing,
    [theme.breakpoints.up('lg')]: {
      display: 'block',
      marginTop: theme.spacing(11),
    },
    '& .at-style-responsive .at-share-btn': {
      margin: 0,
      ...theme.mixins.marginRight(pxToRem(10)),
    },
    '& a:last-child': {
      backgroundColor: '#FF8707 !important',

      '& svg': {
        fill: `${theme.palette.common.white} !important`
      }
    }
  },
  header: {
    [theme.breakpoints.up('lg')]: {
      marginBottom: pxToRem(24),
    },
  },
}));

export default useStyles;
